<!-- Toast global para notificaciones -->
<p-toast></p-toast>

<p-card>
  <div class="row">
    <div class="col-12">
      <!-- Mismo ritmo de cabecera que el expediente: título 1.5rem y bajada en muted. -->
      <h1 class="wc-title">Configuración de Cartera</h1>
      <p class="wc-subtitle">
        Los cortes mensuales de cartera para Contabilidad y las reglas con las que el sistema cobra la mora, detecta duplicados y califica
        al cliente.
      </p>
    </div>
  </div>

  <p-tabView styleClass="tabview-plain">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span>Cortes</span>
      </ng-template>
      <ng-template pTemplate="content">
        <!-- Cards de estadísticas -->
        <div class="row mb-4 flex" *ngIf="!loadingStats">
          <div class="col-3">
            <div class="stat-card">
              <div class="stat-content">
                <h3>{{ statistics.totalReports || 0 }}</h3>
                <p>Total de reportes</p>
              </div>
              <i class="fa-solid fa-file-csv stat-icon"></i>
            </div>
          </div>
          <div class="col-3">
            <div class="stat-card">
              <div class="stat-content">
                <h3>{{ statistics.successfulReports || 0 }}</h3>
                <p>Reportes exitosos</p>
              </div>
              <i class="fa-solid fa-check-circle stat-icon text-success"></i>
            </div>
          </div>
          <div class="col-3">
            <div class="stat-card">
              <div class="stat-content">
                <h3>{{ statistics.failedReports || 0 }}</h3>
                <p>Reportes fallidos</p>
              </div>
              <i class="fa-solid fa-exclamation-circle stat-icon text-danger"></i>
            </div>
          </div>
          <div class="col-3">
            <div class="stat-card distribution-card">
              <div class="distribution-content">
                <div class="distribution-side left-side">
                  <div class="distribution-number">{{ statistics.automaticReports || 0 }}</div>
                  <div class="distribution-label">Automáticos</div>
                  <i class="fa-solid fa-robot distribution-icon text-primary"></i>
                </div>
                <div class="distribution-divider"></div>
                <div class="distribution-side right-side">
                  <div class="distribution-number">{{ statistics.manualReports || 0 }}</div>
                  <div class="distribution-label">Manuales</div>
                  <i class="fa-solid fa-hand-pointer distribution-icon text-info"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Skeleton para estadísticas. La cuarta casilla es de DOS valores (automáticos vs manuales) y el
       esqueleto la pintaba como las otras tres: al llegar los datos la tarjeta cambiaba de forma. -->
        <div class="row mb-4 flex" *ngIf="loadingStats" aria-busy="true" aria-label="Cargando las estadísticas de cortes">
          <div class="col-3" *ngFor="let item of [1, 2, 3]">
            <div class="stat-card">
              <div class="stat-content">
                <p-skeleton width="3rem" height="2rem"></p-skeleton>
                <p-skeleton width="80%" height="1rem" styleClass="mt-2"></p-skeleton>
              </div>
              <p-skeleton width="2.5rem" height="2.5rem" shape="circle"></p-skeleton>
            </div>
          </div>
          <div class="col-3">
            <div class="stat-card distribution-card">
              <div class="distribution-content">
                <div class="distribution-side" *ngFor="let s of [1, 2]">
                  <p-skeleton width="2rem" height="1.8rem"></p-skeleton>
                  <p-skeleton width="5rem" height="0.85rem" styleClass="mt-2"></p-skeleton>
                  <p-skeleton width="1.8rem" height="1.8rem" shape="circle" styleClass="mt-2"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botones de acción principales -->
        <div class="row mb-4">
          <div class="col-12">
            <div class="action-buttons">
              <button
                pButton
                type="button"
                label="Generar Corte"
                icon="fa-solid fa-plus"
                class="p-button-primary"
                [appHasPermission]="['wallet-config', 'create']"
                (click)="mainActions('GENERATE')"
              ></button>
              <button
                pButton
                type="button"
                label="Ver Estadísticas"
                icon="fa-solid fa-chart-bar"
                class="p-button-outlined"
                [appHasPermission]="['wallet-config', 'get-all']"
                (click)="mainActions('STATS')"
              ></button>
              <button
                pButton
                type="button"
                label="Configuraciones de Corte"
                icon="fa-solid fa-cogs"
                class="p-button-outlined"
                [appHasPermission]="['wallet-config', 'get-all']"
                (click)="mainActions('CONFIGURATIONS')"
              ></button>
            </div>
          </div>
        </div>

        <!-- Tabla principal con historial -->
        <div class="row">
          <div class="col-12">
            <app-main-table
              [columns]="columns"
              [actions]="actions"
              [additionalFilters]="cortesOnly"
              [pluralEntityName]="'reportes de corte'"
              [apiService]="apiWalletConfigService"
              (onAction)="actionMethods($event)"
            >
            </app-main-table>

            <!-- Los otros seis reportes que comparten este historial no se generan ni se configuran aquí. -->
            <p class="wc-elsewhere">
              Aquí solo están los cortes de cartera. El resto de los reportes —CENTRAL, cuadre, cartera, avance, mora y la hoja de carga— y
              quién se llevó cada uno viven en
              <a routerLink="/admin/reports">Reportería</a>.
            </p>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span>Reglas</span>
      </ng-template>
      <ng-template pTemplate="content">
        <app-wallet-rules></app-wallet-rules>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</p-card>

<!-- Dialog para generar corte -->
<p-dialog
  header="Generar Corte de Cartera"
  [(visible)]="showGenerateDialog"
  [modal]="true"
  [style]="{ width: '500px' }"
  [closable]="!loadingGenerate"
>
  <form [formGroup]="generateForm" class="p-fluid">
    <div class="field">
      <label for="cutoffDate"> <span class="p-error">*</span>Fecha de Corte: </label>
      <p-calendar
        id="cutoffDate"
        formControlName="cutoffDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        [maxDate]="today"
        placeholder="Seleccione la fecha de corte"
        [appendTo]="'body'"
      >
      </p-calendar>
      <small class="p-error" *ngIf="generateForm.get('cutoffDate')?.invalid && generateForm.get('cutoffDate')?.touched">
        La fecha de corte es obligatoria
      </small>
    </div>

    <!-- <div class="field">
      <div class="field-checkbox">
        <p-checkbox 
          id="incluirDetalles"
          formControlName="incluirDetalles"
          [binary]="true">
        </p-checkbox>
        <label for="incluirDetalles">Incluir detalles adicionales en el reporte</label>
      </div>
    </div> -->
  </form>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      icon="fa-solid fa-times"
      class="p-button-text"
      [disabled]="loadingGenerate"
      (click)="hideGenerateDialog()"
    ></button>
    <button
      pButton
      type="button"
      label="Generar y Descargar Reporte"
      icon="fa-solid fa-download"
      [loading]="loadingGenerate"
      [disabled]="generateForm.invalid"
      (click)="generateCorte()"
    ></button>
  </ng-template>
</p-dialog>

<!-- Dialog para estadísticas -->
<p-dialog header="Estadísticas de Reportes" [(visible)]="showStatsDialog" [modal]="true" [style]="{ width: '600px' }">
  <div class="stats-grid">
    <div class="stat-item">
      <h4>Reportes del mes actual</h4>
      <p class="stat-number">{{ statistics.currentMonthReports || 0 }}</p>
    </div>
    <div class="stat-item">
      <h4>Promedio de tiempo de procesamiento</h4>
      <p class="stat-number">{{ statistics.avgProcessingTime || '0' }} min</p>
    </div>
    <div class="stat-item">
      <h4>Último corte generado</h4>
      <p class="stat-text">{{ statistics.lastReportDate | date: 'dd/MM/yyyy HH:mm' || 'N/A' }}</p>
    </div>
    <div class="stat-item">
      <h4>Tamaño promedio de archivo</h4>
      <p class="stat-text">{{ statistics.avgFileSize || 'N/A' }}</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cerrar" icon="fa-solid fa-times" class="p-button-text" (click)="hideStatsDialog()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog para configuraciones de corte -->
<p-dialog
  header="Configuraciones de Corte"
  [(visible)]="showConfigurationsDialog"
  [modal]="true"
  [style]="{ width: '1000px' }"
  [maximizable]="true"
>
  <!-- Carga: la forma de las tarjetas de configuración que vienen, no un spinner centrado. -->
  <div *ngIf="loadingConfigurations" aria-busy="true" aria-label="Cargando las configuraciones de corte">
    <div class="mb-3 flex justify-content-between align-items-center">
      <p-skeleton height="1.2rem" width="18rem"></p-skeleton>
      <p-skeleton height="2.5rem" width="11rem" borderRadius="6px"></p-skeleton>
    </div>
    <div class="config-card mb-3" *ngFor="let c of [1, 2, 3]" [ngClass]="'sk-fade-' + c">
      <div class="config-header">
        <p-skeleton height="1.1rem" width="14rem"></p-skeleton>
        <p-skeleton height="1.5rem" width="6rem" borderRadius="999px"></p-skeleton>
      </div>
      <p-skeleton height="0.85rem" width="70%" styleClass="mt-2"></p-skeleton>
      <p-skeleton height="0.85rem" width="45%" styleClass="mt-2"></p-skeleton>
    </div>
  </div>

  <div *ngIf="!loadingConfigurations">
    <!-- Botón para crear nueva configuración -->
    <div class="mb-3 flex justify-content-between align-items-center">
      <h4>Configuracion Automática de Corte</h4>
      <button
        pButton
        type="button"
        label="Nueva Configuración"
        icon="fa-solid fa-plus"
        class="p-button-primary"
        [appHasPermission]="['wallet-config', 'create']"
        (click)="showCreateConfigDialog()"
      ></button>
    </div>

    <!-- Configuración Principal (siempre primero) -->
    <div *ngIf="primaryConfiguration" class="config-card primary-config mb-3">
      <div class="config-header">
        <div class="config-title">
          <h6>{{ primaryConfiguration.name }}</h6>
          <p-tag value="Principal" severity="info" class="ml-2"></p-tag>
          <p-tag
            [value]="getConfigStatusLabel(primaryConfiguration.isActive)"
            [severity]="getConfigStatusSeverity(primaryConfiguration.isActive)"
            class="ml-2"
          >
          </p-tag>
        </div>
        <div class="config-actions">
          <button
            pButton
            type="button"
            icon="fa-solid fa-edit"
            class="p-button-sm p-button-outlined p-button-primary"
            [appHasPermission]="['wallet-config', 'update']"
            (click)="configurationActions('EDIT', primaryConfiguration)"
            pTooltip="Editar configuración"
          ></button>
          <button
            pButton
            type="button"
            [icon]="primaryConfiguration.isActive ? 'fa-solid fa-toggle-on' : 'fa-solid fa-toggle-off'"
            class="p-button-sm p-button-outlined p-button-warning"
            [appHasPermission]="['wallet-config', 'update']"
            (click)="configurationActions('TOGGLE', primaryConfiguration)"
            [pTooltip]="primaryConfiguration.isActive ? 'Desactivar' : 'Activar'"
          ></button>
        </div>
      </div>

      <div class="config-content">
        <div class="config-row">
          <div class="config-item">
            <label>Programación:</label>
            <span>{{ cronToReadable(primaryConfiguration.cronExpression) }}</span>
          </div>
          <div class="config-item">
            <label>Destinatarios:</label>
            <span>{{ formatRecipientsList(primaryConfiguration.recipients) }}</span>
          </div>
        </div>
        <div class="config-row">
          <div class="config-item">
            <label>Clientes:</label>
            <span>{{ formatClientCount(primaryConfiguration.clientIds) }}</span>
          </div>
          <div class="config-item" *ngIf="primaryConfiguration.lastExecution">
            <label>Última ejecución:</label>
            <span>{{ primaryConfiguration.lastExecution.date | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </div>
        <div class="config-row" *ngIf="primaryConfiguration.description">
          <div class="config-item full-width">
            <label>Descripción:</label>
            <span>{{ primaryConfiguration.description }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Configuraciones Adicionales -->
    <div *ngIf="additionalConfigurations.length > 0">
      <h4 class="mb-3">Configuraciones Adicionales</h4>
      <div class="config-card" *ngFor="let config of additionalConfigurations" [class.inactive-config]="!config.isActive">
        <div class="config-header">
          <div class="config-title">
            <h6>{{ config.name }}</h6>
            <p-tag [value]="getConfigStatusLabel(config.isActive)" [severity]="getConfigStatusSeverity(config.isActive)" class="ml-2">
            </p-tag>
          </div>
          <div class="config-actions">
            <button
              pButton
              type="button"
              icon="fa-solid fa-edit"
              class="p-button-sm p-button-outlined p-button-primary"
              [appHasPermission]="['wallet-config', 'update']"
              (click)="configurationActions('EDIT', config)"
              pTooltip="Editar configuración"
            ></button>
            <button
              pButton
              type="button"
              [icon]="config.isActive ? 'fa-solid fa-toggle-on' : 'fa-solid fa-toggle-off'"
              class="p-button-sm p-button-outlined p-button-warning"
              [appHasPermission]="['wallet-config', 'update']"
              (click)="configurationActions('TOGGLE', config)"
              [pTooltip]="config.isActive ? 'Desactivar' : 'Activar'"
            ></button>
            <button
              pButton
              type="button"
              icon="fa-solid fa-trash"
              class="p-button-sm p-button-outlined p-button-danger"
              [appHasPermission]="['wallet-config', 'delete']"
              (click)="configurationActions('DELETE', config)"
              pTooltip="Eliminar configuración"
            ></button>
          </div>
        </div>

        <div class="config-content">
          <div class="config-row">
            <div class="config-item">
              <label>Programación:</label>
              <span>{{ cronToReadable(config.cronExpression) }}</span>
            </div>
            <div class="config-item">
              <label>Destinatarios:</label>
              <span>{{ formatRecipientsList(config.recipients) }}</span>
            </div>
          </div>
          <div class="config-row">
            <div class="config-item">
              <label>Clientes:</label>
              <span>{{ formatClientCount(config.clientIds) }}</span>
            </div>
            <div class="config-item" *ngIf="config.lastExecution">
              <label>Última ejecución:</label>
              <span>{{ config.lastExecution.date | date: 'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
          <div class="config-row" *ngIf="config.description">
            <div class="config-item full-width">
              <label>Descripción:</label>
              <span>{{ config.description }}</span>
            </div>
          </div>
          <div class="config-row">
            <div class="config-item">
              <label>Creado por:</label>
              <span>{{ config.createdBy.names }} {{ config.createdBy.lastNames }}</span>
            </div>
            <div class="config-item">
              <label>Fecha de creación:</label>
              <span>{{ config.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensaje cuando no hay configuraciones adicionales -->
    <div *ngIf="additionalConfigurations.length === 0 && !loadingConfigurations" class="text-center mt-4">
      <i class="fa-solid fa-cogs text-6 text-color-secondary"></i>
      <h4 class="mt-2">No hay configuraciones adicionales</h4>
      <p class="text-color-secondary">La configuración principal es suficiente para el funcionamiento básico del sistema.</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cerrar"
      icon="fa-solid fa-times"
      class="p-button-text"
      (click)="hideConfigurationsDialog()"
    ></button>
  </ng-template>
</p-dialog>

<!-- Dialog para crear/editar configuración -->
<p-dialog
  [header]="configFormMode === 'CREATE' ? 'Nueva Configuración de Corte' : 'Editar Configuración'"
  [(visible)]="showConfigFormDialog"
  [modal]="true"
  [style]="{ width: '700px' }"
  [closable]="!loadingConfigForm"
>
  <form [formGroup]="configForm" class="p-fluid config-form">
    <!-- Nombre -->
    <div class="field">
      <label for="configName"> <span class="p-error">*</span>Nombre de la configuración: </label>
      <input
        id="configName"
        type="text"
        pInputText
        formControlName="name"
        placeholder="Ej: Corte mensual clientes premium"
        [maxlength]="100"
      />
      <small class="p-error" *ngIf="configForm.get('name')?.invalid && configForm.get('name')?.touched">
        <span *ngIf="configForm.get('name')?.errors?.['required']">El nombre es obligatorio</span>
        <span *ngIf="configForm.get('name')?.errors?.['minlength']">El nombre debe tener al menos 3 caracteres</span>
        <span *ngIf="configForm.get('name')?.errors?.['maxlength']">El nombre no puede exceder 100 caracteres</span>
      </small>
    </div>

    <!-- Descripción -->
    <div class="field">
      <label for="configDescription">Descripción (opcional):</label>
      <textarea
        id="configDescription"
        pInputTextarea
        formControlName="description"
        [rows]="3"
        [maxlength]="500"
        placeholder="Descripción de la configuración y su propósito"
      >
      </textarea>
      <small class="text-600">{{ configForm.get('description')?.value?.length || 0 }}/500 caracteres</small>
      <small class="p-error" *ngIf="configForm.get('description')?.invalid && configForm.get('description')?.touched">
        <span *ngIf="configForm.get('description')?.errors?.['maxlength']">La descripción no puede exceder 500 caracteres</span>
      </small>
    </div>

    <!-- Expresión Cron -->
    <div class="field cron-field">
      <label for="configCron"> <span class="p-error">*</span>Programación (Expresión Cron): </label>
      <div class="cron-input-group">
        <div class="cron-preset-container">
          <p-dropdown
            formControlName="cronPreset"
            [options]="cronPresets"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione una programación predefinida"
            (onChange)="onCronPresetChange($event)"
          >
          </p-dropdown>
          <button
            pButton
            type="button"
            icon="fa-solid fa-keyboard"
            class="p-button-outlined"
            pTooltip="Escribir expresión personalizada"
            (click)="showCustomCron = !showCustomCron"
          ></button>
        </div>

        <!-- Campo para expresión cron personalizada -->
        <div *ngIf="showCustomCron" class="cron-custom-input">
          <input
            id="configCron"
            type="text"
            pInputText
            formControlName="cronExpression"
            placeholder="Ej: 0 9 1 * * (primer día del mes a las 9:00 AM)"
          />
        </div>

        <!-- Descripción legible de la expresión cron -->
        <div *ngIf="configForm.get('cronExpression')?.value" class="cron-description">
          <small class="text-primary">
            <i class="fa-solid fa-clock"></i>
            {{ getCronDescription(configForm.get('cronExpression')?.value) }}
          </small>
        </div>
      </div>

      <small class="p-error" *ngIf="configForm.get('cronExpression')?.invalid && configForm.get('cronExpression')?.touched">
        <span *ngIf="configForm.get('cronExpression')?.errors?.['required']">La expresión cron es obligatoria</span>
        <span *ngIf="configForm.get('cronExpression')?.errors?.['pattern']">Formato de expresión cron inválido</span>
      </small>
    </div>

    <!-- Destinatarios -->
    <div class="field recipients-field">
      <label for="configRecipients"> <span class="p-error">*</span>Emails de destinatarios: </label>
      <textarea
        id="configRecipients"
        pInputTextarea
        formControlName="recipients"
        placeholder="contador@empresa.com, finanzas@empresa.com"
        [rows]="3"
      >
      </textarea>
      <small class="text-600">Separe múltiples emails con comas. Máximo 10 destinatarios.</small>
      <small class="p-error" *ngIf="configForm.get('recipients')?.invalid && configForm.get('recipients')?.touched">
        <span *ngIf="configForm.get('recipients')?.errors?.['required']">Debe especificar al menos un destinatario</span>
        <span *ngIf="configForm.get('recipients')?.errors?.['pattern']">Uno o más emails tienen formato inválido</span>
        <span *ngIf="configForm.get('recipients')?.errors?.['maxRecipients']">No puede agregar más de 10 destinatarios</span>
      </small>
    </div>

    <!-- Filtro de Clientes -->
    <div class="field clients-field">
      <label for="configClients">Filtrar por clientes específicos (opcional):</label>
      <p-multiSelect
        id="configClients"
        formControlName="clientIds"
        [options]="availableClients"
        optionLabel="name"
        optionValue="id"
        placeholder="Todos los clientes (dejar vacío para incluir todos)"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        display="chip"
      >
      </p-multiSelect>
      <small class="text-600">Si no selecciona clientes, se incluirán todos en el corte.</small>
    </div>

    <!-- Estado Activo -->
    <div class="field checkbox-field">
      <div class="field-checkbox">
        <p-checkbox id="configActive" formControlName="isActive" [binary]="true"> </p-checkbox>
        <label for="configActive">Activar configuración inmediatamente</label>
      </div>
      <small class="text-600">Las configuraciones inactivas no ejecutarán cortes automáticos.</small>
    </div>

    <!-- Configuración Principal (solo para admin) -->
    <div class="field checkbox-field" *ngIf="canCreatePrimary && configFormMode === 'CREATE'">
      <div class="field-checkbox">
        <p-checkbox id="configPrimary" formControlName="isPrimary" [binary]="true"> </p-checkbox>
        <label for="configPrimary">Establecer como configuración principal</label>
      </div>
      <small class="text-600">Solo puede existir una configuración principal. Reemplazará la actual si se selecciona.</small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancelar"
      icon="fa-solid fa-times"
      class="p-button-text"
      [disabled]="loadingConfigForm"
      (click)="hideConfigFormDialog()"
    ></button>
    <button
      pButton
      type="button"
      [label]="configFormMode === 'CREATE' ? 'Crear Configuración' : 'Actualizar Configuración'"
      [icon]="configFormMode === 'CREATE' ? 'fa-solid fa-plus' : 'fa-solid fa-save'"
      [loading]="loadingConfigForm"
      [disabled]="configForm.invalid"
      (click)="saveConfiguration()"
    ></button>
  </ng-template>
</p-dialog>

<!-- Dialog de confirmación para eliminar configuración -->
<p-confirmDialog
  [style]="{ width: '550px' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
  acceptButtonStyleClass="p-button-danger"
  defaultFocus="reject"
>
</p-confirmDialog>
